import {HTTP_METHODS} from '@/utils/constants/httpMethods';
import {API_VERSION} from '@/utils/constants/commonConstants';
import {buildQueryParams} from '@/utils/commons';

export const TIER_CONFIG = {
  TIERS: {
    endPoint: 'tiers/tier-setup',
    method: HTTP_METHODS.GET
  },
  GET_TIER_DETAILS: (tierID) => ({
    endPoint: `tiers/${encodeURIComponent(tierID)}`,
    method: HTTP_METHODS.GET,
    version: API_VERSION.V1
  }),
  CREATE_UPDATE_TIER: {
    endPoint: 'tiers',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
  },
  TIER_STORES: (tierID, queryParams, page, paginationSize) => {
    const params = {
      ...Object.fromEntries(new URLSearchParams(queryParams)),
      limit: paginationSize,
      page
    };
    return {
      endPoint: `tiers/${encodeURIComponent(tierID)}/stores?${buildQueryParams(params)}`,
      method: HTTP_METHODS.GET
    };
  },
  CREATE_TIER_OPTIONS: {
    endPoint: 'tiers/create-tier-options',
    method: HTTP_METHODS.GET,
    version: API_VERSION.V1
  },
  MOVE_STORES: (tierID) => ({
    endPoint: `tiers/${encodeURIComponent(tierID)}/move-stores`,
    method: HTTP_METHODS.POST
  }),
  UPLOAD_TIER_STORES: {
    endPoint: 'tiers/upload-stores',
    method: HTTP_METHODS.POST
  },
  UPLOAD_TIER_IMAGE: {
    endPoint: 'tiers/image',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1,
    contentType: 'multipart/form-data'
  },
  GET_FILTERED_STORES_BY_STOREID: (tierID, searchArr, page, limit) => {
    const params = {page, limit, storeId: searchArr};
    return {
      endPoint: `tiers/${encodeURIComponent(tierID)}/filtering-stores-by-store-id?${buildQueryParams(params)}`,
      method: HTTP_METHODS.GET,
      version: API_VERSION.V1,
      headers: {siteId: 21}
    };
  },
  GET_FILTERED_STORES_BY_DATE: (tierID, searchArr, page, limit) => {
    const params = {filterDate: searchArr, page, limit};
    return {
      endPoint: `tiers/${encodeURIComponent(tierID)}/filtering-stores-by-date?${buildQueryParams(params)}`,
      method: HTTP_METHODS.GET,
      version: API_VERSION.V1,
      headers: {siteId: 21}
    };
  }
};
